import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'app/redux/store';

import { CommentsConfig, CommentsResponse, CommentsState, CommentsTypeEnum } from '../types';

const initialState: CommentsState = {
  comments: [],
  replyingCommentUuid: '',
  commentTypeFilter: null,
  reportingCommentUuid: '',
  commentsConfig: {
    enableComments: null,
    enableCommentsAutoAproval: null,
    enableCommentsAnswersAutoAppoval: null,
    enableCommentsReactionLike: null,
    enableCommentsReactionLove: null,
    enableCommentsReactionSupport: null,
    enableCommentsReactionFunny: null,
    enableCommentsReactionGenius: null,
    enableCommentsReactionInteresting: null,
    enableCommentsReactionDislike: null,
  },
  fetchedComments: false,
};

const commentsSlice = createSlice({
  name: 'comments',
  initialState,
  reducers: {
    setCommentsAction(state, action: PayloadAction<CommentsResponse>) {
      state.fetchedComments = true;
      state.comments = action.payload.comments;
    },

    clearCommentsAction(state) {
      state.fetchedComments = false;
      state.comments = [];
    },

    setReplyingCommentUuidAction(state, action: PayloadAction<string>) {
      state.replyingCommentUuid = action.payload;
    },

    setReportingCommentUuidAction(state, action: PayloadAction<string>) {
      state.reportingCommentUuid = action.payload;
    },

    setCommentTypeFilterAction(state, action: PayloadAction<CommentsTypeEnum | null>) {
      state.commentTypeFilter = action.payload;
    },

    setCommentConfigAction(state, action: PayloadAction<CommentsConfig>) {
      state.commentsConfig = action.payload;
    },
  },
});

export const {
  setCommentsAction,
  clearCommentsAction,
  setReplyingCommentUuidAction,
  setCommentTypeFilterAction,
  setReportingCommentUuidAction,
  setCommentConfigAction,
} = commentsSlice.actions;

export const getComments = (state: RootState): CommentsState => state.comments;

export default commentsSlice.reducer;
